export const GET_SEARCH_REQUESTED  = 'GET_SEARCH_REQUESTED';
export const GET_SEARCH_SUCCESS    = 'GET_SEARCH_SUCCESS';
export const GET_SEARCH_FAILED     = 'GET_SEARCH_FAILED';
export const RESET_SEARCH          = 'RESET_SEARCH';
export const NAVIGATE_TO_NEW_SEARCH = 'NAVIGATE_TO_NEW_SEARCH';
